import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mergeProps as $4vDl6$mergeProps, filterDOMProps as $4vDl6$filterDOMProps, useId as $4vDl6$useId } from "@react-aria/utils";
import { useFocusable as $4vDl6$useFocusable, getFocusableTreeWalker as $4vDl6$getFocusableTreeWalker } from "@react-aria/focus";
import { usePress as $4vDl6$usePress, useFocusWithin as $4vDl6$useFocusWithin } from "@react-aria/interactions";
import { useLabel as $4vDl6$useLabel } from "@react-aria/label";
import { useLocale as $4vDl6$useLocale } from "@react-aria/i18n";
var $884aeceb3d67f00f$export$3b7b268d09480394 = new WeakMap();
function $0d5c49892c1215da$export$37b0961d2f4751e2(props, state, ref) {
  var value = props.value,
    children = props.children,
    ariaLabel = props['aria-label'],
    ariaLabelledby = props['aria-labelledby'];
  var isDisabled = props.isDisabled || state.isDisabled;
  var hasChildren = children != null;
  var hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
  if (!hasChildren && !hasAriaLabel) console.warn('If you do not provide children, you must specify an aria-label for accessibility');
  var checked = state.selectedValue === value;
  var onChange = function onChange(e) {
    e.stopPropagation();
    state.setSelectedValue(value);
  };
  var _$4vDl6$usePress = $4vDl6$usePress({
      isDisabled: isDisabled
    }),
    pressProps = _$4vDl6$usePress.pressProps;
  var _$4vDl6$useFocusable = $4vDl6$useFocusable($4vDl6$mergeProps(props, {
      onFocus: function onFocus() {
        return state.setLastFocusedValue(value);
      }
    }), ref),
    focusableProps = _$4vDl6$useFocusable.focusableProps;
  var interactions = $4vDl6$mergeProps(pressProps, focusableProps);
  var domProps = $4vDl6$filterDOMProps(props, {
    labelable: true
  });
  var tabIndex = state.lastFocusedValue === value || state.lastFocusedValue == null ? 0 : -1;
  if (isDisabled) tabIndex = undefined;
  return {
    inputProps: $4vDl6$mergeProps(domProps, _objectSpread(_objectSpread({}, interactions), {}, {
      type: 'radio',
      name: $884aeceb3d67f00f$export$3b7b268d09480394.get(state),
      tabIndex: tabIndex,
      disabled: isDisabled,
      checked: checked,
      value: value,
      onChange: onChange
    })),
    isDisabled: isDisabled,
    isSelected: checked
  };
}
function $430f30ed08ec25fa$export$62b9571f283ff5c2(props, state) {
  var name = props.name,
    validationState = props.validationState,
    isReadOnly = props.isReadOnly,
    isRequired = props.isRequired,
    isDisabled = props.isDisabled,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? 'vertical' : _props$orientation;
  var _$4vDl6$useLocale = $4vDl6$useLocale(),
    direction = _$4vDl6$useLocale.direction;
  var _$4vDl6$useLabel = $4vDl6$useLabel(_objectSpread(_objectSpread({}, props), {}, {
      // Radio group is not an HTML input element so it
      // shouldn't be labeled by a <label> element.
      labelElementType: 'span'
    })),
    labelProps = _$4vDl6$useLabel.labelProps,
    fieldProps = _$4vDl6$useLabel.fieldProps;
  var domProps = $4vDl6$filterDOMProps(props, {
    labelable: true
  });
  // When the radio group loses focus, reset the focusable radio to null if
  // there is no selection. This allows tabbing into the group from either
  // direction to go to the first or last radio.
  var _$4vDl6$useFocusWithi = $4vDl6$useFocusWithin({
      onBlurWithin: function onBlurWithin() {
        if (!state.selectedValue) state.setLastFocusedValue(null);
      }
    }),
    focusWithinProps = _$4vDl6$useFocusWithi.focusWithinProps;
  var onKeyDown = function onKeyDown(e) {
    var nextDir;
    switch (e.key) {
      case 'ArrowRight':
        if (direction === 'rtl' && orientation !== 'vertical') nextDir = 'prev';else nextDir = 'next';
        break;
      case 'ArrowLeft':
        if (direction === 'rtl' && orientation !== 'vertical') nextDir = 'next';else nextDir = 'prev';
        break;
      case 'ArrowDown':
        nextDir = 'next';
        break;
      case 'ArrowUp':
        nextDir = 'prev';
        break;
      default:
        return;
    }
    e.preventDefault();
    var walker = $4vDl6$getFocusableTreeWalker(e.currentTarget, {
      from: e.target
    });
    var nextElem;
    if (nextDir === 'next') {
      nextElem = walker.nextNode();
      if (!nextElem) {
        walker.currentNode = e.currentTarget;
        nextElem = walker.firstChild();
      }
    } else {
      nextElem = walker.previousNode();
      if (!nextElem) {
        walker.currentNode = e.currentTarget;
        nextElem = walker.lastChild();
      }
    }
    if (nextElem) {
      // Call focus on nextElem so that keyboard navigation scrolls the radio into view
      nextElem.focus();
      state.setSelectedValue(nextElem.value);
    }
  };
  var groupName = $4vDl6$useId(name);
  $884aeceb3d67f00f$export$3b7b268d09480394.set(state, groupName);
  return {
    radioGroupProps: $4vDl6$mergeProps(domProps, _objectSpread(_objectSpread({
      // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
      role: 'radiogroup',
      onKeyDown: onKeyDown,
      'aria-invalid': validationState === 'invalid' || undefined,
      'aria-errormessage': props['aria-errormessage'],
      'aria-readonly': isReadOnly || undefined,
      'aria-required': isRequired || undefined,
      'aria-disabled': isDisabled || undefined,
      'aria-orientation': orientation
    }, fieldProps), focusWithinProps)),
    labelProps: labelProps
  };
}
export { $0d5c49892c1215da$export$37b0961d2f4751e2 as useRadio, $430f30ed08ec25fa$export$62b9571f283ff5c2 as useRadioGroup };